import { Descriptions, Divider, Tag } from "antd";
import { selectCurrentBusiness } from "../../../businessesSlice";
import { useAppSelector } from "../../../../../app/hooks";
import { MissingTag } from "../BusinessDetailsModal";

export default function BusinessPersons() {
  const currentBusiness = useAppSelector(selectCurrentBusiness);

  return (
    <>
      {currentBusiness.persons?.length > 0 ? (
        <>
          {currentBusiness.persons?.map((p, i) => (
            <>
              <Divider />
              <Descriptions
                title={"Person " + (i + 1)}
                labelStyle={{ opacity: 0.6, width: "130px" }}
              >
                <Descriptions.Item label={"First Name"}>
                  {p.firstName}
                </Descriptions.Item>
                <Descriptions.Item label={"Last Name"}>
                  {p.lastName}
                </Descriptions.Item>
                <Descriptions.Item label={"Phone"}>
                  {!p?.phone?.number
                    ? MissingTag
                    : `${p.phone?.countryCode} ${p?.phone?.number}`}
                </Descriptions.Item>
                <Descriptions.Item label={"Email"}>
                  {!p.email ? MissingTag : p.email}
                </Descriptions.Item>
                <Descriptions.Item label={"Date Of Birth"}>
                  {!p.dateOfBirth ? MissingTag : p.dateOfBirth}
                </Descriptions.Item>
                <Descriptions.Item label={"Roles"}>
                  <div
                    style={{
                      display: "flex",
                      flexBasis: "250px",
                      flexWrap: "wrap",
                    }}
                  >
                    {p.roles.map((r) => (
                      <Tag style={{ marginBottom: "8px" }}>{r}</Tag>
                    ))}
                  </div>
                </Descriptions.Item>
                <Descriptions.Item label={"Address"}>
                  {!p.address?.street
                    ? MissingTag
                    : `${p.address?.street} ${p.address?.houseNumber}, ${p.address?.city}, ${p.address?.country}`}
                </Descriptions.Item>
                {p?.isCustom && (
                  <Descriptions.Item label={"Is Custom"}>
                    <Tag>CUSTOM PERSON</Tag>
                  </Descriptions.Item>
                )}
              </Descriptions>
            </>
          ))}
        </>
      ) : (
        "No persons information available"
      )}
    </>
  );
}
